import React from "react";

const CanvasPointerToolBadge = ({
  t,
  mode,
  aPressed,
  ctrlPressed,
  shiftPressed,
  mouseScreenPos,
  visible,
  newBoxStart,
  openColor = "#ff0000",
  closeColor = "#0000ff",
}) => {
  const isBboxTool = mode === "edit" && ctrlPressed;

  const getLabel = () => {
    if (mode === "view") {
      return t("bbox.help.mode.view");
    }

    if (mode === "setting") {
      return t("bbox.help.mode.setting");
    }

    if (mode === "edit") {
      if (aPressed) return t("bbox.help.tool.rect");

      if (ctrlPressed) {
        if (newBoxStart?.type === "open") {
          return t("bbox.help.bboxCreateGuide.creatingOpen");
        }

        if (newBoxStart?.type === "close") {
          return t("bbox.help.bboxCreateGuide.creatingClose");
        }

        return t("bbox.help.tool.bbox");
      }

      if (shiftPressed) return t("bbox.help.tool.line");

      return t("bbox.help.mode.edit");
    }

    return "";
  };

  const getColor = () => {
    if (mode === "setting") return "#1677ff";
    if (mode === "view") return "#666";

    if (mode === "edit") {
      if (aPressed) return "#13c2c2";

      if (ctrlPressed) {
        if (newBoxStart?.type === "open") return openColor;
        if (newBoxStart?.type === "close") return closeColor;

        return "#fa8c16";
      }

      if (shiftPressed) return "#722ed1";

      return "#52c41a";
    }

    return "#666";
  };

  const label = getLabel();

  if (!visible || !label || !mouseScreenPos) {
    return null;
  }

  const activeType = newBoxStart?.type;

  return (
    <div
      style={{
        position: "fixed",
        left: mouseScreenPos.x + 14,
        top: Math.max(8, mouseScreenPos.y - 34),
        zIndex: 9999,
        pointerEvents: "none",
        background: getColor(),
        color: "#fff",
        borderRadius: 10,
        padding: isBboxTool ? "6px 10px" : "4px 10px",
        fontSize: 12,
        fontWeight: 700,
        boxShadow: "0 3px 10px rgba(0,0,0,0.25)",
        whiteSpace: "nowrap",
        userSelect: "none",
        minWidth: isBboxTool ? 150 : undefined,
      }}
    >
      <div>{label}</div>

      {isBboxTool && (
        <div
          style={{
            marginTop: 5,
            paddingTop: 5,
            borderTop: "1px solid rgba(255,255,255,0.35)",
            display: "flex",
            flexDirection: "column",
            gap: 2,
            fontSize: 11,
            fontWeight: 600,
            lineHeight: 1.25,
          }}
        >
          <div
            style={{
              opacity: activeType === "close" ? 0.45 : 1,
              display: "flex",
              alignItems: "center",
              gap: 5,
            }}
          >
            <span
              style={{
                width: 8,
                height: 8,
                borderRadius: 999,
                background: openColor,
                border: "1px solid rgba(255,255,255,0.9)",
              }}
            />
            {t("bbox.help.bboxCreateGuide.leftOpen")}
          </div>

          <div
            style={{
              opacity: activeType === "open" ? 0.45 : 1,
              display: "flex",
              alignItems: "center",
              gap: 5,
            }}
          >
            <span
              style={{
                width: 8,
                height: 8,
                borderRadius: 999,
                background: closeColor,
                border: "1px solid rgba(255,255,255,0.9)",
              }}
            />
            {t("bbox.help.bboxCreateGuide.rightClose")}
          </div>
        </div>
      )}
    </div>
  );
};

export default CanvasPointerToolBadge;